export default __webpack_public_path__ + "static/media/cory_1.14de4091.png";